import forEach from 'lodash/forEach';
import get from 'lodash/get';
function getKey(width, height, adProvider) {
    return `${width}_${height}_${adProvider}`;
}
export default class CompanionCache {
    constructor() {
        this.displaySlotFormats = {};
        this.displaySlotIds = {};
    }
    reset() {
        this.displaySlotFormats = {};
        this.displaySlotIds = {};
    }
    loadDisplaySlots(slots) {
        forEach(slots, (slot) => {
            const { elementId, name } = slot;
            this.displaySlotIds[elementId] = elementId;
            forEach(slot.formats, (format) => {
                forEach(format.dimensions, (dimension) => {
                    const key = getKey(dimension[0], dimension[1], format.adProvider);
                    this.displaySlotFormats[key] = { elementId, name, format };
                });
            });
        });
    }
    getCompanionSlot(width, height, adProvider) {
        const key = getKey(width, height, adProvider);
        const slot = this.displaySlotFormats[key];
        if (!get(slot, 'format.isCompanion')) {
            return null;
        }
        return slot;
    }
    removeDisplaySlot(width, height, adProvider) {
        const key = getKey(width, height, adProvider);
        const slot = this.displaySlotFormats[key];
        const elementId = get(slot, 'elementId');
        if (!elementId) {
            return;
        }
        delete this.displaySlotFormats[key];
        delete this.displaySlotIds[elementId];
    }
}
